export default "__VITE_ASSET__CJ1Uicx7__"